<template>
    <div>
        <CRow>
            <CCol md="12">
                <!-- Aqui va lo movil -->
                <div v-if="$mq === 'mobile'">
                    <CCard
                        v-bind:key="trabajador.rutTrabajador"
                        v-for="trabajador in trabajadores"
                    >
                        <CCardHeader>
                            <CRow class="center-content">
                                <CCol col="12">
                                    <CRow class="center-content">
                                        <div>
                                            <strong>{{$utils.formatearRut(trabajador.rutTrabajador)}}</strong>
                                        </div> 
                                    </CRow>
                                    <CRow class="center-content">
                                        <div>
                                            <strong>{{ trabajador.nombreTrabajador }}</strong>
                                        </div>
                                    </CRow>
                                    <CRow class="center-content" style="padding-top: 15px;">
                                        <div style="font-size: 0.9rem">
                                            <span>Documentos:</span><span>({{totalTrabajadoresDocumentos}}/{{totalTrabajadores}})</span>
                                        </div>
                                    </CRow>
                                    <CRow class="center-content">
                                        <div v-if="tipoDocumentoSelected.valor == 'liquidaciones' && (!portContador ? (trabajador.documento != null?(trabajador.documento.estadoDocumento == 1 || trabajador.documento.estadoDocumento == 3):true) : true)">
                                            <span v-if="(!portContador ? (trabajador.documento != null?(trabajador.documento.estadoDocumento == 1 || trabajador.documento.estadoDocumento == 3):true) : true)">
                                                <div v-if="trabajador.documento == null || !trabajador.documento.hayDocumento">
                                                    <CButton
                                                        size="sm" variant="ghost"
                                                        content="Sin Documento"
                                                            v-tippy="{ 
                                                                placement: 'top',
                                                                arrow: true, 
                                                                arrowType: 'round', 
                                                                animation:'fade',
                                                                theme: 'google',
                                                                followCursor : true,
                                                            }"
                                                        >
                                                        <CIcon :name="$utils.iconosGenerales('nada')" size="xl"/> Sin Documentos
                                                    </CButton>
                                                </div>
                                                <div v-else>
                                                    <CButton class="btn-pad btnPrincipalVapp w-100" size="sm" color="success"
                                                        :href="trabajador.documentos.urlDocumento" 
                                                        target="_blank" 
                                                    >
                                                        <CIcon :name="$utils.iconosGenerales('descarga')"></CIcon> Descargar Liquidación
                                                    </CButton>
                                                    <CButton class="btn-pad btnPrincipalVapp w-100" size="sm" color="success"
                                                        @click="seleccionarTrabajadores(empresa, trabajador, trabajador.documento)"
                                                    >
                                                        <CIcon :name="$utils.iconosGenerales('mostrar')"></CIcon> Ver Liquidación
                                                    </CButton>
                                                </div>
                                            </span>
                                        </div>

                                        <div v-else-if="tipoDocumentoSelected.valor == 'contratos' && (!portContador ? (trabajador.documento != null?(trabajador.documento.estadoDocumento == 1 || trabajador.documento.estadoDocumento == 3):true) : true)">
                                            <div v-if="(trabajador.documento != null ? !portContador ? trabajador.documento.estadoDocumento == 1 || trabajador.documento.estadoDocumento == 3 : true : false)">
                                                <div v-if="!isLoadingGenerarDocumento && !trabajador.isLoadingGenerarDocumento">
                                                    <span v-if="trabajador.ultimosDocumentos.ultimoContrato == undefined && trabajador.ultimosDocumentos.ultimoAnexo == undefined && trabajador.ultimosDocumentos.ultimoFinq == undefined">
                                                        <CButton
                                                            size="sm" variant="ghost"
                                                            content="Sin Documento"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }"
                                                            >
                                                            <CIcon
                                                                :name="$utils.iconosGenerales('nada')"
                                                            />
                                                        </CButton>
                                                    </span>
                                                    <span v-if="trabajador.ultimosDocumentos.ultimoContrato != undefined">
                                                        <CButton class="btn-pad btnPrincipalVapp w-100" size="sm" color="success"
                                                            v-show="trabajador.ultimosDocumentos != undefined && trabajador.ultimosDocumentos.ultimoContrato != undefined" 
                                                            @click="descargarDocumento(trabajador.ultimosDocumentos.ultimoContrato)"
                                                            :href="trabajador.ultimosDocumentos.ultimoContrato.urlDocumento" 
                                                            target="_blank"
                                                        ><CIcon :name="$utils.iconosGenerales('descarga')"></CIcon>
                                                            Descargar Contrato
                                                        </CButton>
                                                        <CButton class="btn-pad btnPrincipalVapp w-100" size="sm" color="success"
                                                            v-show="trabajador.ultimosDocumentos != undefined && trabajador.ultimosDocumentos.ultimoContrato != undefined"
                                                            @click="seleccionarTrabajadores(empresa, trabajador, trabajador.ultimosDocumentos.ultimoContrato)"
                                                        ><CIcon :name="$utils.iconosGenerales('mostrar')"></CIcon>
                                                            Ver Contrato
                                                        </CButton>
                                                    </span>
                                                    <span v-if="trabajador.ultimosDocumentos.ultimoAnexo != undefined">
                                                        <hr>
                                                        <span v-show="trabajador.ultimosDocumentos.ultimoContrato != undefined"> | </span>
                                                        <CButton class="btn-pad btnPrincipalVapp w-100" size="sm" color="success"
                                                            v-show="trabajador.ultimosDocumentos != undefined 
                                                            && trabajador.ultimosDocumentos.ultimoAnexo != undefined" 
                                                            @click="descargarDocumento(trabajador.ultimosDocumentos.ultimoAnexo)"
                                                            :href="trabajador.ultimosDocumentos.ultimoAnexo.urlDocumento" 
                                                            target="_blank"
                                                        ><CIcon name="cilDataTransferDown"></CIcon>
                                                            Descargar Anexo
                                                        </CButton>
                                                        <CButton class="btn-pad btnPrincipalVapp w-100" size="sm"
                                                            @click="seleccionarTrabajadores(empresa, trabajador, trabajador.ultimosDocumentos.ultimoAnexo)"
                                                            v-show="trabajador.ultimosDocumentos != undefined && 
                                                            trabajador.ultimosDocumentos.ultimoAnexo != undefined"
                                                        ><CIcon name="cilFindInPage"></CIcon>
                                                            Ver Anexo
                                                        </CButton>
                                                    </span>
                                                    <span v-if="trabajador.ultimosDocumentos.ultimoFinq != undefined">
                                                        <hr>
                                                        <span v-show="trabajador.documento.estadoDocumento != 1 && trabajador.documento.estadoDocumento !=3 && portContador && !periodoCerrado"> | </span>
                                                        <CButton class="btn-pad btnPrincipalVapp w-100" size="sm" color="success"
                                                            v-show="trabajador.ultimosDocumentos != undefined && trabajador.ultimosDocumentos.ultimoFinq != undefined" 
                                                            @click="descargarDocumento(trabajador.ultimosDocumentos.ultimoFinq)"
                                                            :href="trabajador.ultimosDocumentos.ultimoFinq.urlDocumento" 
                                                            target="_blank"
                                                        ><CIcon name="cilDataTransferDown"></CIcon>
                                                            Descargar Finiquito
                                                        </CButton>
                                                        <CButton class="btn-pad btnPrincipalVapp w-100" size="sm" color="success"
                                                            v-show="trabajador.ultimosDocumentos != undefined && 
                                                            trabajador.ultimosDocumentos.ultimoFinq != undefined"
                                                            @click="seleccionarTrabajadores(empresa, trabajador, trabajador.ultimosDocumentos.ultimoFinq)"
                                                        ><CIcon name="cilFindInPage"></CIcon>
                                                            Ver Finiquito
                                                        </CButton>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-else>
                                            <CButton
                                            size="sm" variant="ghost"
                                            ><CIcon name="cilMeh" />
                                            </CButton>
                                        </div>  
                                    </CRow>

                                    <CRow class="center-content" style="padding-top: 20px" v-show="trabajador.documento != null">
                                        <span style="font-size: 1rem">Enviar Documentos:</span>
                                        <CCol col="12">
                                            <OpcionesEnvioCorreo
                                                :mostrarAlertas="true"
                                                :mostrarEnvioCorreo="true"
                                                :empresa="empresa"
                                                :portContador="portContador"
                                                :isLoadingEnvioTodos="empresa.isLoadingEnvioTodos"
                                                :trabajador="trabajador"
                                                :tipoDocumentos="tipoDocumentoSelected"
                                                :mesSelected="mesSelected"
                                                :anioSelected="periodoSelected"
                                                :filtrarPorPeriodo="mostrarPeriodo"
                                            />
                                        </CCol>
                                    </CRow>

                                    <!-- Boton desplegar -->
                                    <CRow class="center-content" style="padding-top: 20px">
                                        <div>
                                            <CLink
                                                v-show="trabajador.documento != null"
                                                class="card-header-action btn-minimize "
                                                @click="expandirTarjeta(trabajador)"
                                                >
                                                <CIcon
                                                    :name="`cil-chevron-${!trabajador.expandirTrabajador ? 'left' : 'right'}`"
                                                />
                                            </CLink>
                                        </div>
                                    </CRow>
                                </CCol>
                            </CRow>
                        </CCardHeader>

                        <div>
                            <CCollapse :show="trabajador.expandirTrabajador" >
                                <div v-if="tipoDocumentoSelected.valor == 'liquidaciones'">
                                    <CCard
                                        class="card-overlay" 
                                        :class="{ 'is-expanded': trabajador.expandirTrabajador }"
                                    >
                                        <CCardHeader>
                                            <CRow class="center-content">
                                                <CCol col="12">
                                                    <CRow class="center-content">
                                                        <strong>{{$utils.formatearRut(trabajador.rutTrabajador)}}</strong>
                                                    </CRow>
                                                    <CRow class="center-content">
                                                        <strong>{{ trabajador.nombreTrabajador }}</strong>
                                                    </CRow>  
                                                </CCol>
                                            </CRow>
                                        </CCardHeader>

                                        <CCardBody>
                                            <CCard
                                                v-bind:key="documento.idDocumento"
                                                v-for="documento in trabajador.documentos"
                                            >
                                                <CRow class="center-content">
                                                    <CCol col="12">
                                                        <CRow class="center-content" style="padding-top: 15px">
                                                            <div>
                                                                <strong>Documento: {{ documento.tipo }} </strong>
                                                            </div>
                                                        </CRow>
                                                        <CRow class="center-content">
                                                            <div>
                                                                <strong>Emitido {{$utils.formatFechaDocumento(trabajador.documento.ultimaGeneracion)}}</strong>
                                                            </div>
                                                        </CRow>
                                                        <CRow class="center-content" style="padding-top: 15px">
                                                            <div>
                                                                <span v-if="trabajador.documentos.isLoadingDoc">
                                                                    <CIcon style="color:#0b7689;" :content="$options.freeSet.cilLoopCircular" class="imgr" />
                                                                </span>
                                                                <span v-else-if="(!portContador ? (trabajador.documento != null?(trabajador.documento.estadoDocumento == 1 || trabajador.documento.estadoDocumento == 3):true) : true)">
                                                                    <span>
                                                                        <a 
                                                                            :href="trabajador.documento.urlDocumento" 
                                                                            target="_blank" 
                                                                            style="text-decoration: none; color:#0b7689; padding: 10px;" 
                                                                            content="Descargar Documento"
                                                                        >
                                                                            <CIcon :name="$utils.iconosGenerales('descarga')" size="xl"/>
                                                                        </a>
                                                                    </span>
                                                                    /
                                                                    <span>
                                                                        <a  
                                                                            style="text-decoration: none; color:#0b7689; padding: 10px;" 
                                                                            content="Ver Documento"
                                                                            @click="seleccionarTrabajadores(empresa, trabajador, trabajador.documento)">
                                                                            <CIcon :name="$utils.iconosGenerales('mostrar')" size="xl"/>
                                                                        </a>
                                                                    </span>
                                                                </span>
                                                                <span  v-else>
                                                                    <CButton
                                                                    size="sm" variant="ghost"
                                                                    content="Sin Documento"
                                                                    >
                                                                        <CIcon :name="$utils.iconosGenerales('nada')"/>
                                                                    </CButton>
                                                                </span>
                                                                <span>
                                                                    <span v-if="(portContador)?trabajador.documento.estadoDocumento != 1 && trabajador.documento.estadoDocumento != 3 : false">
                                                                        / <span>
                                                                            <a  
                                                                                style="text-decoration: none; color:#0b7689; padding: 10px;" 
                                                                                content="Eliminar Documento"
                                                                                    @click="eliminarDocumento(empresa, trabajador, documento)">
                                                                                <CIcon :name="$utils.iconosGenerales('cancelar')" size="xl"/>
                                                                            </a>
                                                                        </span>
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </CRow>
                                                        <CRow class="content-center" style="margin-top: 15px; margin-bottom: 15px">
                                                            <span v-if="!trabajador.documento" class="large-badge-movil">
                                                                <CBadge shape="pill" color="secondary">
                                                                    Sin Estado
                                                                </CBadge>
                                                            </span>
                                                            <span v-else>
                                                                <CBadge shape="pill" :color="getColorEstadoDocumento(trabajador.documento)" class="large-badge-movil">
                                                                    {{$utils.getEstadoDocumento(trabajador.documento)}}
                                                                </CBadge>
                                                            </span>
                                                        </CRow>
                                                        
                                                    </CCol>
                                                </CRow>
                                            </CCard>
                                            <CRow class="content-center" style="padding-top: 10px;">
                                                <CLink
                                                    v-show="trabajador.documento != null"
                                                    class="card-header-action btn-minimize "
                                                    @click="expandirTarjeta(trabajador)"
                                                    >
                                                    <CIcon
                                                        :name="`cil-chevron-${trabajador.expandirTrabajador ? 'right' : 'left'}`"
                                                    />
                                                </CLink>
                                            </CRow>
                                        </CCardBody>
                                    </CCard>
                                </div>

                                <div v-else-if="tipoDocumentoSelected.valor == 'contratos'">
                                    <div>
                                            <CCard 
                                            :class="{ 'is-expanded': trabajador.expandirTrabajador }"
                                            class="card-overlay"
                                        >
                                            <CCardHeader>
                                                <CRow>
                                                    <CCol col="12">
                                                        <CRow class="content-center">
                                                            <strong>{{$utils.formatearRut(trabajador.rutTrabajador)}}</strong>
                                                        </CRow>
                                                        <CRow class="content-center">
                                                            <strong>{{ trabajador.nombreTrabajador }}</strong>
                                                        </CRow>  
                                                    </CCol>
                                                </CRow>
                                            </CCardHeader>
                                            <CCardBody>
                                                <CCard
                                                    v-bind:key="documento.idDocumento"
                                                    v-for="documento in trabajador.documentos"
                                                >
                                                    <CCardBody>
                                                        <CRow>
                                                            <CCol col="12">
                                                                <CRow class="content-center">
                                                                    <span><strong>Tipo Documento: </strong>{{ documento.tipo }}</span>
                                                                </CRow>
                                                                <CRow class="content-center">
                                                                    <span><strong>Fecha de Emision: </strong>{{$utils.formatFechaDocumentoNormal(documento.fechaEmision)}}</span>
                                                                </CRow>
                                                                <CRow class="content-center">
                                                                    <span><strong>Fecha Inicio Contrato: </strong>{{$utils.formatFechaDocumentoNormal(documento.fechaContrato)}}</span>
                                                                </CRow>
                                                                <CRow class="content-center">
                                                                    <span><strong>Fecha de Vencimiento: </strong>{{$utils.formatFechaDocumentoNormal(documento.fechaVencimiento)}}</span>
                                                                </CRow>
                                                                <CRow class="content-center">
                                                                    <span><strong>Fecha Termino: </strong>{{$utils.formatFechaDocumentoNormal(documento.fechaTermino)}}</span>
                                                                </CRow>
                                                                <CRow class="content-center" style="padding-top: 15px;">
                                                                    <span v-if="documento.isGenerando || empresa.isLoadingGenerarDocumento || trabajador.isLoadingGenerarDocumento">
                                                                        <CIcon :content="$options.freeSet.cilLoopCircular" class="imgr" />
                                                                    </span>
                                                                    <div v-else>
                                                                        <CButton
                                                                            v-if="documento.documento == null"
                                                                            size="sm" variant="ghost"
                                                                            style="font-size: 0.9rem"
                                                                            > 
                                                                            <CIcon size="lg"
                                                                                :name="$utils.iconosGenerales('nada')"
                                                                            /> Sin Documentos
                                                                        </CButton>
                                                                        <span v-else>
                                                                            <span v-show="!portContador ? documento.documento.estadoDocumento == 1 || documento.documento.estadoDocumento ==3 : true">
                                                                                <a 
                                                                                    :href="documento.documento.urlDocumento" 
                                                                                    target="_blank" 
                                                                                    style="text-decoration: none; color:#0b7689; padding: 10px;" 
                                                                                    content="Descargar Documento"
                                                                                >
                                                                                    <CIcon :name="$utils.iconosGenerales('descarga')" size="xl"/>
                                                                                </a>
                                                                                /
                                                                                <a
                                                                                    style="text-decoration: none; color:#0b7689; padding: 10px;"
                                                                                    content="Ver Documento"
                                                                                    @click="seleccionarTrabajadores(empresa, trabajador, documento.documento)">
                                                                                    <CIcon :name="$utils.iconosGenerales('mostrar')" size="xl"/>
                                                                                </a>
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                </CRow>
                                                                <span v-if="!documento.documento">
                                                                    <CRow class="center-content-badge">
                                                                        <CBadge shape="pill" color="secondary" class="large-badge-movil">
                                                                            Sin Estado 
                                                                        </CBadge>
                                                                    </CRow>
                                                                </span>
                                                                <span v-else>
                                                                    <CRow class="center-content-badge">
                                                                        <CBadge shape="pill" :color="getColorEstadoDocumento(documento.documento)" class="large-badge-movil">
                                                                            {{ $utils.getEstadoDocumento(documento.documento) }}                                                               
                                                                        </CBadge>
                                                                    </CRow>
                                                                </span>
                                                            </CCol>
                                                        </CRow>
                                                    </CCardBody>
                                                </CCard>
                                                <CRow class="center-content-expandir">
                                                    <CLink
                                                        v-show="trabajador.documento != null"
                                                        class="card-header-action btn-minimize "
                                                        @click="expandirTarjeta(trabajador)"
                                                        >
                                                        <CIcon
                                                            :name="`cil-chevron-${trabajador.expandirTrabajador ? 'right' : 'left'}`"
                                                        />
                                                    </CLink>
                                                </CRow>
                                            </CCardBody>
                                        </CCard>
                                        
                                    </div>
                                </div>
                            </CCollapse>
                        </div>
                    </CCard>
                </div>
                <!-- Aqui va lo web -->
                <div v-else>
                    <!-- Tabla trabajadores InfoEmpresa -->
                    <div v-if="!tablaLista">
                        <CCard
                            v-bind:key="trabajador.rutTrabajador"
                            v-for="trabajador in trabajadores"
                        >
                            <CCardHeader>
                                <CRow>
                                    <span>
                                        <div
                                            class="card-header-action d-flex justify-content-center"
                                        >
                                            <CLink
                                            v-show="trabajador.documento != null"
                                            class="card-header-action btn-minimize "
                                            @click="expandirTarjeta(trabajador)"
                                            >
                                            <CIcon
                                                :name="`cil-chevron-${trabajador.expandirTrabajador ? 'bottom' : 'top'}`"
                                            />
                                            </CLink>
                                        </div>
                                    </span>
                                    <CCol md="3">
                                        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; text-align: center;">
                                            <div>
                                                <strong>{{$utils.formatearRut(trabajador.rutTrabajador)}} </strong>
                                            </div>
                                            <div>
                                                <strong>{{ trabajador.nombreTrabajador }}</strong>
                                            </div> 
                                        </div>
                                    </CCol>
                                    <CCol md="5" class="center-content">
                                        <div>
                                            <!-- no se refleja el toral correctamente aún
                                                <span>Documentos: </span><span>({{totalTrabajadoresDocumentos}}/{{totalTrabajadores}})</span>-->
                                            <div>
                                                <div>
                                                    <div v-if="tipoDocumentoSelected.valor == 'liquidaciones' && (!portContador ? (trabajador.documento != null?(trabajador.documento.estadoDocumento == 1 || trabajador.documento.estadoDocumento == 3):true) : true)">
                                                        <span v-if="(!portContador ? (trabajador.documento != null?(trabajador.documento.estadoDocumento == 1 || trabajador.documento.estadoDocumento == 3):true) : true)">
                                                            <div v-if="trabajador.documento == null || !trabajador.documento.hayDocumento">
                                                                <CButton
                                                                    size="sm" variant="ghost"
                                                                    content="Sin Documento"
                                                                        v-tippy="{ 
                                                                            placement: 'top',
                                                                            arrow: true, 
                                                                            arrowType: 'round', 
                                                                            animation:'fade',
                                                                            theme: 'google',
                                                                            followCursor : true,
                                                                        }"
                                                                    >
                                                                    <CIcon :name="$utils.iconosGenerales('nada')" size="lg"/>
                                                                </CButton>
                                                            </div>
                                                            <div v-else>
                                                                <CButton class="btn-pad btnPrincipalVapp w-100" size="sm" color="success"
                                                                    :href="trabajador.documentos.urlDocumento" 
                                                                    target="_blank" 
                                                                >
                                                                    <CIcon :name="$utils.iconosGenerales('descarga')"></CIcon> Descargar Liquidación
                                                                </CButton>
                                                                <CButton class="btn-pad btnPrincipalVapp w-100" size="sm" color="success"
                                                                    @click="seleccionarTrabajadores(empresa, trabajador, trabajador.documento)"
                                                                >
                                                                    <CIcon :name="$utils.iconosGenerales('mostrar')"></CIcon> Ver Liquidación
                                                                </CButton>
                                                            </div>
                                                        </span>
                                                    </div>
                                                    <div v-else-if="tipoDocumentoSelected.valor == 'contratos' && (!portContador ? (trabajador.documento != null?(trabajador.documento.estadoDocumento == 1 || trabajador.documento.estadoDocumento == 3):true) : true)">
                                                        <div v-if="(trabajador.documento != null ? !portContador ? trabajador.documento.estadoDocumento == 1 || trabajador.documento.estadoDocumento == 3 : true : false)">
                                                            <CRow v-if="!isLoadingGenerarDocumento && !trabajador.isLoadingGenerarDocumento">
                                                                <CCol class="center-content">
                                                                    <span v-if="trabajador.ultimosDocumentos.ultimoContrato == undefined && trabajador.ultimosDocumentos.ultimoAnexo == undefined && trabajador.ultimosDocumentos.ultimoFinq == undefined">
                                                                        <CButton
                                                                            size="sm" variant="ghost"
                                                                            content="Sin Documento"
                                                                                v-tippy="{ 
                                                                                    placement: 'top',
                                                                                    arrow: true, 
                                                                                    arrowType: 'round', 
                                                                                    animation:'fade',
                                                                                    theme: 'google',
                                                                                    followCursor : true,
                                                                                }"
                                                                            >
                                                                            <CIcon
                                                                                :name="$utils.iconosGenerales('nada')" size="xl"
                                                                            />
                                                                        </CButton>
                                                                    </span>
                                                                    <span v-if="trabajador.ultimosDocumentos.ultimoContrato != undefined" style="padding: 5px">
                                                                        <CButton class="btn-pad btnPrincipalVapp w-100" size="sm" color="success"
                                                                            v-show="trabajador.ultimosDocumentos != undefined && trabajador.ultimosDocumentos.ultimoContrato != undefined" 
                                                                            @click="descargarDocumento(trabajador.ultimosDocumentos.ultimoContrato)"
                                                                            :href="trabajador.ultimosDocumentos.ultimoContrato.urlDocumento" 
                                                                            target="_blank"
                                                                        ><CIcon :name="$utils.iconosGenerales('descarga')"></CIcon>
                                                                            Descargar Contrato
                                                                        </CButton>
                                                                        <CButton class="btn-pad btnPrincipalVapp w-100" size="sm" color="success"
                                                                            v-show="trabajador.ultimosDocumentos != undefined && trabajador.ultimosDocumentos.ultimoContrato != undefined"
                                                                            @click="seleccionarTrabajadores(empresa, trabajador, trabajador.ultimosDocumentos.ultimoContrato)"
                                                                        ><CIcon :name="$utils.iconosGenerales('mostrar')"></CIcon>
                                                                            Ver Contrato
                                                                        </CButton>
                                                                    </span>
                                                                    <span v-if="trabajador.ultimosDocumentos.ultimoAnexo != undefined">
                                                                        <span v-show="trabajador.ultimosDocumentos.ultimoContrato != undefined"> | </span>
                                                                        <CButton class="btn-pad btnPrincipalVapp w-100" size="sm" color="success"
                                                                            v-show="trabajador.ultimosDocumentos != undefined 
                                                                            && trabajador.ultimosDocumentos.ultimoAnexo != undefined" 
                                                                            @click="descargarDocumento(trabajador.ultimosDocumentos.ultimoAnexo)"
                                                                            :href="trabajador.ultimosDocumentos.ultimoAnexo.urlDocumento" 
                                                                            target="_blank"
                                                                        ><CIcon :name="$utils.iconosGenerales('descarga')"></CIcon>
                                                                            Descargar Anexo
                                                                        </CButton>
                                                                        <CButton class="btn-pad btnPrincipalVapp w-100" size="sm"
                                                                            @click="seleccionarTrabajadores(empresa, trabajador, trabajador.ultimosDocumentos.ultimoAnexo)"
                                                                            v-show="trabajador.ultimosDocumentos != undefined && 
                                                                            trabajador.ultimosDocumentos.ultimoAnexo != undefined"
                                                                        ><CIcon :name="$utils.iconosGenerales('mostrar')"></CIcon>
                                                                            Ver Anexo
                                                                        </CButton>
                                                                    </span>
                                                                    <span v-if="trabajador.ultimosDocumentos.ultimoFinq != undefined">
                                                                        <span v-show="trabajador.documento.estadoDocumento != 1 && trabajador.documento.estadoDocumento !=3 && portContador && !periodoCerrado"> | </span>
                                                                        <CButton class="btn-pad btnPrincipalVapp w-100" size="sm" color="success"
                                                                            v-show="trabajador.ultimosDocumentos != undefined && trabajador.ultimosDocumentos.ultimoFinq != undefined" 
                                                                            @click="descargarDocumento(trabajador.ultimosDocumentos.ultimoFinq)"
                                                                            :href="trabajador.ultimosDocumentos.ultimoFinq.urlDocumento" 
                                                                            target="_blank"
                                                                        ><CIcon :name="$utils.iconosGenerales('descarga')"></CIcon>
                                                                            Descargar Finiquito
                                                                        </CButton>
                                                                        <CButton class="btn-pad btnPrincipalVapp w-100" size="sm" color="success"
                                                                            v-show="trabajador.ultimosDocumentos != undefined && 
                                                                            trabajador.ultimosDocumentos.ultimoFinq != undefined"
                                                                            @click="seleccionarTrabajadores(empresa, trabajador, trabajador.ultimosDocumentos.ultimoFinq)"
                                                                        ><CIcon :name="$utils.iconosGenerales('mostrar')"></CIcon>
                                                                            Ver Finiquito
                                                                        </CButton>
                                                                    </span>
                                                                </CCol>
                                                            </CRow>
                                                            <span v-else>
                                                                <CIcon :content="$options.freeSet.cilLoopCircular" class="imgr" />
                                                            </span>
                                                        </div>
                                                        <div v-else>
                                                            <span v-if="isLoadingGenerarDocumento || trabajador.isLoadingGenerarDocumento">
                                                                <CIcon :content="$options.freeSet.cilLoopCircular" class="imgr" />
                                                            </span>
                                                            <span v-else>
                                                                <CButton
                                                                    size="sm" variant="ghost"
                                                                    content="Sin Documento"
                                                                        v-tippy="{ 
                                                                            placement: 'top',
                                                                            arrow: true, 
                                                                            arrowType: 'round', 
                                                                            animation:'fade',
                                                                            theme: 'google',
                                                                            followCursor : true,
                                                                        }"
                                                                    >
                                                                    <CIcon :name="$utils.iconosGenerales('nada')" size="xl"/>
                                                                </CButton>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <CButton
                                                        size="sm" variant="ghost"
                                                        content="Sin Documento"
                                                            v-tippy="{ 
                                                                placement: 'top',
                                                                arrow: true, 
                                                                arrowType: 'round', 
                                                                animation:'fade',
                                                                theme: 'google',
                                                                followCursor : true,
                                                            }"
                                                        ><CIcon :name="$utils.iconosGenerales('nada')" size="xl"/>
                                                        </CButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </CCol>
                                    <CCol md="3">
                                        <!--<span>Enviar Documentos:</span>-->
                                        <div class="center-content">
                                            <div>
                                                <OpcionesEnvioCorreo
                                                    :mostrarAlertas="true"
                                                    :mostrarEnvioCorreo="true"
                                                    :empresa="empresa"
                                                    :portContador="portContador"
                                                    :isLoadingEnvioTodos="empresa.isLoadingEnvioTodos"
                                                    :trabajador="trabajador"
                                                    :tipoDocumentos="tipoDocumentoSelected"
                                                    :mesSelected="mesSelected"
                                                    :anioSelected="periodoSelected"
                                                    :filtrarPorPeriodo="mostrarPeriodo"
                                                />
                                            </div>
                                        </div>
                                    </CCol>
                                </CRow>
                                <CCollapse :show="trabajador.expandirTrabajador" style="padding-top: 20px;">
                                    <div v-if="tipoDocumentoSelected.valor == 'liquidaciones'">
                                        <CCard 
                                            v-bind:key="documento.idDocumento"
                                            v-for="documento in trabajador.documentos"
                                        >
                                            <CCardHeader>
                                                <CRow>
                                                    <CCol md="4" class="col-mob"
                                                        v-tippy="{
                                                            content: 'Nombre Documento',
                                                            placement: 'top',
                                                            arrow: true,
                                                            arrowType: 'round',
                                                            animation: 'fade',
                                                            theme: 'google',
                                                        }"
                                                    >
                                                        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; text-align: center;">
                                                            <div v-if="documento && documento.nombreDocumento">
                                                                <strong>{{ trabajador.documento.nombreDocumento }}</strong>   
                                                            </div>
                                                            <div>
                                                                <strong>Emitido {{$utils.formatFechaDocumento(documento.ultimaGeneracion)}}</strong>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <CCol md="4" class="col-mob">
                                                        <div class="center-content">
                                                            <span v-if="trabajador.documentos.isLoadingDoc">
                                                                <CIcon style="color:#0b7689;" :content="$options.freeSet.cilLoopCircular" class="imgr" />
                                                            </span>
                                                            <span v-else-if="(!portContador ? (trabajador.documento != null?(trabajador.documento.estadoDocumento == 1 || trabajador.documento.estadoDocumento == 3):true) : true)">
                                                                <span>
                                                                    <a 
                                                                        :href="trabajador.documento.urlDocumento" 
                                                                        target="_blank" 
                                                                        style="text-decoration: none; color:#0b7689; padding: 5px" 
                                                                        content="Descargar Documento"
                                                                        v-tippy="{ 
                                                                            placement: 'top',
                                                                            arrow: true, 
                                                                            arrowType: 'round', 
                                                                            animation:'fade',
                                                                            theme: 'google',
                                                                            followCursor : true,
                                                                        }"
                                                                    >
                                                                        <CIcon :name="$utils.iconosGenerales('descarga')" size="xl"/>
                                                                    </a>
                                                                </span>
                                                                /
                                                                <span> 
                                                                    <a  
                                                                        style="text-decoration: none; color:#0b7689; padding: 5px" 
                                                                        content="Ver Documento"
                                                                        v-tippy="{ 
                                                                            placement: 'top',
                                                                            arrow: true, 
                                                                            arrowType: 'round', 
                                                                            animation:'fade',
                                                                            theme: 'google',
                                                                            followCursor : true,
                                                                        }"
                                                                        @click="seleccionarTrabajadores(empresa, trabajador, trabajador.documento)">
                                                                        <CIcon :name="$utils.iconosGenerales('mostrar')" size="xl"/>
                                                                    </a>
                                                                </span>
                                                            </span>
                                                            <span v-else>
                                                                <CButton
                                                                size="sm" variant="ghost"
                                                                content="Sin Documento"
                                                                    v-tippy="{ 
                                                                        placement: 'top',
                                                                        arrow: true, 
                                                                        arrowType: 'round', 
                                                                        animation:'fade',
                                                                        theme: 'google',
                                                                        followCursor : true,
                                                                    }"
                                                                >
                                                                    <CIcon :name="$utils.iconosGenerales('nada')"/>
                                                                </CButton>
                                                            </span>
                                                            <span>
                                                                <span v-if="(portContador)?trabajador.documento.estadoDocumento != 1 && trabajador.documento.estadoDocumento != 3 : false">
                                                                    /<span> 
                                                                        <a  
                                                                            style="text-decoration: none; color:#0b7689; padding: 5px" 
                                                                            content="Eliminar Documento"
                                                                            v-tippy="{ 
                                                                                placement: 'top',
                                                                                arrow: true, 
                                                                                arrowType: 'round', 
                                                                                animation:'fade',
                                                                                theme: 'google',
                                                                                followCursor : true,
                                                                            }"
                                                                             @click="eliminarDocumento(empresa, trabajador, documento)">
                                                                            <CIcon :name="$utils.iconosGenerales('cancelar')" size="xl"/>
                                                                        </a>
                                                                    </span>
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </CCol>
                                                    <CCol md="3" class="col-mob">
                                                        <div class="center-content">
                                                            <span v-if="!trabajador.documento" class="large-badge-movil">
                                                                <CBadge shape="pill" color="secondary">
                                                                    Sin Estado
                                                                </CBadge>
                                                            </span>
                                                            <span v-else>
                                                                <CBadge shape="pill" :color="getColorEstadoDocumento(trabajador.documento)" class="large-badge-movil">
                                                                    {{$utils.getEstadoDocumento(trabajador.documento)}}
                                                                </CBadge>
                                                            </span>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </CCardHeader>
                                        </CCard>
                                    </div>
                                    <div v-else-if="tipoDocumentoSelected.valor == 'contratos'">
                                        <CCard v-for="documento in trabajador.documentos"
                                            v-bind:key="documento.idDocumento">
                                            <CCardHeader>
                                                <CRow>
                                                    <CCol md="1" class="col-mob"
                                                        v-tippy="{
                                                            content: 'Tipo Documento',
                                                            placement: 'top',
                                                            arrow: true,
                                                            arrowType: 'round',
                                                            animation: 'fade',
                                                            theme: 'google',
                                                        }"
                                                    >
                                                        {{ documento.tipo }}
                                                    </CCol>
                                                    <CCol md="2" class="col-mob"
                                                        v-tippy="{
                                                            content: 'Fecha Emision',
                                                            placement: 'top',
                                                            arrow: true,
                                                            arrowType: 'round',
                                                            animation: 'fade',
                                                            theme: 'google',
                                                        }"
                                                    >
                                                        {{$utils.formatFechaDocumentoNormal(documento.fechaEmision)}}
                                                    </CCol>
                                                    <CCol md="2" class="col-mob"
                                                        v-tippy="{
                                                            content: 'Fecha Inicio Contrato',
                                                            placement: 'top',
                                                            arrow: true,
                                                            arrowType: 'round',
                                                            animation: 'fade',
                                                            theme: 'google',
                                                        }"
                                                    >
                                                        {{$utils.formatFechaDocumentoNormal(documento.fechaContrato)}}
                                                    </CCol>
                                                    <CCol md="2" class="col-mob"
                                                        v-tippy="{
                                                            content: 'Fecha de Vencimiento',
                                                            placement: 'top',
                                                            arrow: true,
                                                            arrowType: 'round',
                                                            animation: 'fade',
                                                            theme: 'google',
                                                        }"
                                                    >
                                                        {{$utils.formatFechaDocumentoNormal(documento.fechaVencimiento)}}
                                                    </CCol>
                                                    <CCol md="2" class="col-mob"
                                                        v-tippy="{
                                                            content: 'Fecha Termino',
                                                            placement: 'top',
                                                            arrow: true,
                                                            arrowType: 'round',
                                                            animation: 'fade',
                                                            theme: 'google',
                                                        }"
                                                    >
                                                        {{$utils.formatFechaDocumentoNormal(documento.fechaTermino)}}
                                                    </CCol>
                                                    <CCol md="2" class="col-mob">
                                                        <span v-if="documento.isGenerando || empresa.isLoadingGenerarDocumento || trabajador.isLoadingGenerarDocumento">
                                                            <CIcon :content="$options.freeSet.cilLoopCircular" class="imgr" />
                                                        </span>
                                                        <div v-else>
                                                            <CButton
                                                                v-if="documento.documento == null"
                                                                size="sm" variant="ghost"
                                                                content="Sin Archivo"
                                                                    v-tippy="{ 
                                                                        placement: 'top',
                                                                        arrow: true, 
                                                                        arrowType: 'round', 
                                                                        animation:'fade',
                                                                        theme: 'google',
                                                                        followCursor : true,
                                                                    }"
                                                                >
                                                                <CIcon size="lg"
                                                                    :name="$utils.iconosGenerales('nada')"
                                                                />
                                                            </CButton>
                                                            <span v-else>
                                                                <span v-show="!portContador ? documento.documento.estadoDocumento == 1 || documento.documento.estadoDocumento ==3 : true">
                                                                    <a 
                                                                        :href="documento.documento.urlDocumento" 
                                                                        target="_blank" 
                                                                        style="text-decoration: none; color:#0b7689;" 
                                                                        content="Descargar Documento"
                                                                        v-tippy="{ 
                                                                            placement: 'top',
                                                                            arrow: true, 
                                                                            arrowType: 'round', 
                                                                            animation:'fade',
                                                                            theme: 'google',
                                                                            followCursor : true,
                                                                        }"
                                                                    >
                                                                        <CIcon :name="$utils.iconosGenerales('descarga')" size="xl"/>
                                                                    </a>
                                                                    /
                                                                    <a
                                                                        style="text-decoration: none; color:#0b7689"
                                                                        content="Ver Documento"
                                                                        v-tippy="{ 
                                                                            placement: 'top',
                                                                            arrow: true, 
                                                                            arrowType: 'round', 
                                                                            animation:'fade',
                                                                            theme: 'google',
                                                                            followCursor : true,
                                                                        }"
                                                                        @click="seleccionarTrabajadores(empresa, trabajador, documento.documento)">
                                                                        <CIcon :name="$utils.iconosGenerales('mostrar')" size="xl"/>
                                                                    </a>
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </CCol>
                                                    <CCol md="1" class="col-mob">
                                                        <span v-if="!documento.documento">
                                                            <CBadge shape="pill" color="secondary" class="large-badge-movil">
                                                                Sin Estado 
                                                            </CBadge>
                                                        </span>
                                                        <span v-else>
                                                            <CBadge shape="pill" :color="getColorEstadoDocumento(documento.documento)" class="large-badge-movil">
                                                                {{ $utils.getEstadoDocumento(documento.documento) }}                                                               
                                                            </CBadge>
                                                        </span>
                                                    </CCol>
                                                </CRow>
                                            </CCardHeader>
                                        </CCard>
                                    </div>
                                </CCollapse>
                            </CCardHeader>
                        </CCard>
                    </div>

                    <!-- Tabla trabajadores original -->

                    <div v-else>
                        <a-table
                            :style="{ 'min-height': '50px' }"
                            :indentSize="10"
                            row-key="rutTrabajador"
                            :locale="localeTrabajadores"
                            :columns="columnasTrabajadores"
                            :data-source="trabajadores"
                            :pagination="paginacion"
                            :scroll="{ y: 400 }"
                            size="small"
                            @change="handleTableChange">
                                <span slot="tituloDoc">
                                    <span class="text-truncate" style="overflow:hidden">Dctos.</span>
                                    <span>({{totalTrabajadoresDocumentos}}/{{totalTrabajadores}})</span>
                                </span>
                                <span slot="rutTrabajador" slot-scope="trabajador">
                                    {{$utils.formatearRut(trabajador.rutTrabajador)}}
                                </span>
                                <span slot="documento" slot-scope="trabajador">

                                    <div>
                                        <div v-if="tipoDocumentoSelected.valor == 'liquidaciones' && (!portContador ? (trabajador.documento != null?(trabajador.documento.estadoDocumento == 1 || trabajador.documento.estadoDocumento == 3):true) : true)">
                                            <span v-if="(!portContador ? (trabajador.documento != null?(trabajador.documento.estadoDocumento == 1 || trabajador.documento.estadoDocumento == 3):true) : true)">
                                                <div v-if="trabajador.documento == null || !trabajador.documento.hayDocumento">
                                                    <CButton
                                                        size="sm" variant="ghost"
                                                        content="Sin Documento"
                                                            v-tippy="{ 
                                                                placement: 'top',
                                                                arrow: true, 
                                                                arrowType: 'round', 
                                                                animation:'fade',
                                                                theme: 'google',
                                                                followCursor : true,
                                                            }"
                                                        >
                                                        <CIcon :name="$utils.iconosGenerales('nada')" size="lg"/>
                                                    </CButton>
                                                </div>
                                                <div v-else>
                                                    <a 
                                                        :href="trabajador.documento.urlDocumento" 
                                                        target="_blank" 
                                                        style="text-decoration: none; color:#0b7689;" 
                                                        content="Descargar Documento"
                                                        v-tippy="{ 
                                                            placement: 'top',
                                                            arrow: true, 
                                                            arrowType: 'round', 
                                                            animation:'fade',
                                                            theme: 'google',
                                                            followCursor : true,
                                                        }"
                                                    >
                                                        <CIcon :name="$utils.iconosGenerales('descarga')" size="lg"/>
                                                    </a>
                                                    /
                                                    <a
                                                        style="text-decoration: none; color:#0b7689" 
                                                        @click="seleccionarTrabajadores(empresa, trabajador, trabajador.documento)"
                                                        content="Ver Documento"
                                                        v-tippy="{ 
                                                            placement: 'top',
                                                            arrow: true, 
                                                            arrowType: 'round', 
                                                            animation:'fade',
                                                            theme: 'google',
                                                            followCursor : true,
                                                        }"
                                                    >
                                                        <CIcon :name="$utils.iconosGenerales('mostrar')" size="lg"/>
                                                    </a>
                                                </div>
                                            </span>
                                        </div>
                                        <div v-else-if="tipoDocumentoSelected.valor == 'contratos' && (!portContador ? (trabajador.documento != null?(trabajador.documento.estadoDocumento == 1 || trabajador.documento.estadoDocumento == 3):true) : true)">
                                            <div v-if="(trabajador.documento != null ? !portContador ? trabajador.documento.estadoDocumento == 1 || trabajador.documento.estadoDocumento == 3 : true : false)">
                                            
                                                <CRow v-if="!isLoadingGenerarDocumento && !trabajador.isLoadingGenerarDocumento">
                                                    <CCol>
                                                        <span v-if="trabajador.ultimosDocumentos.ultimoContrato == undefined && trabajador.ultimosDocumentos.ultimoAnexo == undefined && trabajador.ultimosDocumentos.ultimoFinq == undefined">
                                                            <CButton
                                                                size="sm" variant="ghost"
                                                                content="Sin Documento"
                                                                    v-tippy="{ 
                                                                        placement: 'top',
                                                                        arrow: true, 
                                                                        arrowType: 'round', 
                                                                        animation:'fade',
                                                                        theme: 'google',
                                                                        followCursor : true,
                                                                    }"
                                                                >
                                                                <CIcon
                                                                    :name="$utils.iconosGenerales('nada')" size="lg"
                                                                />
                                                            </CButton>
                                                        </span>
                                                        <span v-if="trabajador.ultimosDocumentos.ultimoContrato != undefined">
                                                            <a 
                                                                v-show="trabajador.ultimosDocumentos != undefined && trabajador.ultimosDocumentos.ultimoContrato != undefined" 
                                                                @click="descargarDocumento(trabajador.ultimosDocumentos.ultimoContrato)"
                                                                :href="trabajador.ultimosDocumentos.ultimoContrato.urlDocumento" 
                                                                target="_blank" 
                                                                style="text-decoration: none; color:#0b7689;" 
                                                                content="Descargar Documento Contrato"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }"
                                                            >
                                                                <CIcon :name="$utils.iconosGenerales('descarga')" size="lg"/>
                                                            </a>
                                                            /
                                                            <a
                                                                style="text-decoration: none; color:#0b7689" 
                                                                v-show="trabajador.ultimosDocumentos != undefined && trabajador.ultimosDocumentos.ultimoContrato != undefined"
                                                                @click="seleccionarTrabajadores(empresa, trabajador, trabajador.ultimosDocumentos.ultimoContrato)"
                                                                content="Ver Documento Contrato"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }"
                                                                >
                                                                <CIcon :name="$utils.iconosGenerales('mostrar')" size="lg"/>
                                                            </a>
                                                        </span>
                                                        <span v-if="trabajador.ultimosDocumentos.ultimoAnexo != undefined">
                                                            <span v-show="trabajador.ultimosDocumentos.ultimoContrato != undefined"> | </span>
                                                            <a 
                                                                v-show="trabajador.ultimosDocumentos != undefined 
                                                                && trabajador.ultimosDocumentos.ultimoAnexo != undefined" 
                                                                @click="descargarDocumento(trabajador.ultimosDocumentos.ultimoAnexo)"
                                                                :href="trabajador.ultimosDocumentos.ultimoAnexo.urlDocumento" 
                                                                target="_blank" 
                                                                style="text-decoration: none; color:#0b7689;" 
                                                                content="Descargar Documento Anexo"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }">
                                                                <CIcon :name="$utils.iconosGenerales('descarga')" size="lg"/>
                                                            </a>
                                                            /
                                                            <a
                                                                style="text-decoration: none; color:#0b7689" 
                                                                @click="seleccionarTrabajadores(empresa, trabajador, trabajador.ultimosDocumentos.ultimoAnexo)"
                                                                v-show="trabajador.ultimosDocumentos != undefined && 
                                                                trabajador.ultimosDocumentos.ultimoAnexo != undefined"
                                                                content="Ver Documento Anexo"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }"
                                                                >
                                                                <CIcon :name="$utils.iconosGenerales('mostrar')" size="lg"/>
                                                            </a>
                                                        </span>
                                                        <span v-if="trabajador.ultimosDocumentos.ultimoFinq != undefined" style="padding-left: 15px">
                                                            <span v-show="trabajador.documento.estadoDocumento != 1 && trabajador.documento.estadoDocumento !=3 && portContador && !periodoCerrado"></span>
                                                            <a 
                                                                v-show="trabajador.ultimosDocumentos != undefined && trabajador.ultimosDocumentos.ultimoFinq != undefined" 
                                                                @click="descargarDocumento(trabajador.ultimosDocumentos.ultimoFinq)"
                                                                :href="trabajador.ultimosDocumentos.ultimoFinq.urlDocumento" 
                                                                target="_blank" 
                                                                style="text-decoration: none; color:#0b7689;" 
                                                                content="Descargar Documento Finiquito"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }"
                                                            >
                                                                <CIcon :name="$utils.iconosGenerales('descarga')" size="lg"/>
                                                            </a>
                                                            /
                                                            <a
                                                                style="text-decoration: none; color:#0b7689" 
                                                                v-show="trabajador.ultimosDocumentos != undefined && 
                                                                trabajador.ultimosDocumentos.ultimoFinq != undefined"
                                                                @click="seleccionarTrabajadores(empresa, trabajador, trabajador.ultimosDocumentos.ultimoFinq)"
                                                                content="Ver Documento Finiquito"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }"
                                                                >
                                                                <CIcon :name="$utils.iconosGenerales('mostrar')" size="lg"/>
                                                            </a>
                                                        </span>
                                                    </CCol>
                                                </CRow>
                                                <span v-else>
                                                    <CIcon :content="$options.freeSet.cilLoopCircular" class="imgr" size="lg"/>
                                                </span>
                                            </div>
                                            <div v-else>
                                                <span v-if="isLoadingGenerarDocumento || trabajador.isLoadingGenerarDocumento">
                                                    <CIcon :content="$options.freeSet.cilLoopCircular" class="imgr" size="lg"/>
                                                </span>
                                                <span v-else>
                                                    <!--<a 
                                                        v-show="tipoDocumentoSelected.permiteGenerarDoc"
                                                        @click="generarDocumentoTrabajador(empresa, trabajador)"
                                                        target="_blank" 
                                                        style="text-decoration: none; color:#0b7689;" 
                                                        content="Generar Documentos"
                                                            v-tippy="{ 
                                                                placement: 'top',
                                                                arrow: true, 
                                                                arrowType: 'round', 
                                                                animation:'fade',
                                                                theme: 'google',
                                                                followCursor : true,
                                                            }"
                                                        >
                                                        <CIcon :content="$options.freeSet.cilLibraryAdd" />
                                                    </a>-->
                                                    <CButton
                                                        size="sm" variant="ghost"
                                                        content="Sin Documento"
                                                            v-tippy="{ 
                                                                placement: 'top',
                                                                arrow: true, 
                                                                arrowType: 'round', 
                                                                animation:'fade',
                                                                theme: 'google',
                                                                followCursor : true,
                                                            }"
                                                        >
                                                        <CIcon :name="$utils.iconosGenerales('nada')" size="lg"/>
                                                    </CButton>
                                                    </span>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <CButton
                                            size="sm" variant="ghost"
                                            content="Sin Documento"
                                                v-tippy="{ 
                                                    placement: 'top',
                                                    arrow: true, 
                                                    arrowType: 'round', 
                                                    animation:'fade',
                                                    theme: 'google',
                                                    followCursor : true,
                                                }"
                                            >
                                            <CIcon :name="$utils.iconosGenerales('nada')" size="lg"/>
                                        </CButton>
                                        </div>
                                    </div>
                                </span>
                                <span slot="envioCorreo" slot-scope="trabajador">
                                    <OpcionesEnvioCorreo
                                        :mostrarAlertas="true"
                                        :mostrarEnvioCorreo="true"
                                        :empresa="empresa"
                                        :portContador="portContador"
                                        :isLoadingEnvioTodos="empresa.isLoadingEnvioTodos"
                                        :trabajador="trabajador"
                                        :tipoDocumentos="tipoDocumentoSelected"
                                        :mesSelected="mesSelected"
                                        :anioSelected="periodoSelected"
                                        :filtrarPorPeriodo="mostrarPeriodo"
                                    />
                                    <!--<div v-if="tipoDocumentoSelected.valor == 'contratos'">
                                        
                                        <CButton
                                            v-show="trabajador.ultimosDocumentos == null || (trabajador.ultimosDocumentos.ultimoAnexo == null && trabajador.ultimosDocumentos.ultimoContrato == null)"
                                            size="sm" variant="ghost"
                                            content="Sin Documentos"
                                                v-tippy="{ 
                                                    placement: 'top',
                                                    arrow: true, 
                                                    arrowType: 'round', 
                                                    animation:'fade',
                                                    theme: 'google',
                                                    followCursor : true,
                                                }"
                                            >
                                            <CIcon
                                                :content="$options.freeSet.cilMeh"
                                            />
                                        </CButton>
                                        <CButton
                                            v-show="!trabajador.tieneMailTrabajador && !trabajador.modificarMail"
                                            class="ml-2"
                                            size="sm" variant="ghost"
                                            style="color:#e55353"
                                            content="El trabajador no tiene correo"
                                                v-tippy="{ 
                                                    placement: 'top',
                                                    arrow: true, 
                                                    arrowType: 'round', 
                                                    animation:'fade',
                                                    theme: 'google',
                                                    followCursor : true,
                                                }"
                                            >
                                            <CIcon
                                                :content="$options.freeSet.cilWarning"
                                            />
                                        </CButton>
                                        <CInput
                                            v-model="trabajador.mailModificado"
                                            type="text"
                                            horizontal
                                            placeholder="Correo"
                                            :is-valid="trabajador.mailValido"
                                            v-show="trabajador.modificarMail && !trabajador.isModificandoMail"
                                            @keyup="validarMail(trabajador)">
                                            <template #append>
                                                <CButton 
                                                    color="success" 
                                                    size="sm"
                                                    :disabled="!trabajador.mailValido"
                                                    @click="cambiarCorreoTrabajador(trabajador, empresa.idEmpresa)"
                                                    content="Guardar Correo"
                                                    v-tippy="{ 
                                                        placement: 'top',
                                                        arrow: true, 
                                                        arrowType: 'round', 
                                                        animation:'fade',
                                                        theme: 'google',
                                                        followCursor : true,
                                                    }">
                                                    <CIcon name="cil-check-circle"/>
                                                </CButton>

                                                <CButton
                                                    :content="(trabajador.modificarMail)?'Cancelar':'Modificar Correo'"
                                                    v-tippy="{ 
                                                        placement: 'top',
                                                        arrow: true, 
                                                        arrowType: 'round', 
                                                        animation:'fade',
                                                        theme: 'google',
                                                        followCursor : true,
                                                    }"
                                                    v-show="trabajador.modificarMail"
                                                    color="danger" 
                                                    @click="trabajador.modificarMail = false" size="sm" ><CIcon name="cil-x-circle"/>
                                                </CButton>
                                            </template>
                                        </CInput>
                                            <CButton
                                                v-if="trabajador.ultimosDocumentos.ultimoContrato != undefined || trabajador.ultimosDocumentos.ultimoAnexo != undefined"
                                                size="sm"
                                                class="btnPrincipalVapp"
                                                v-show="((trabajador.ultimosDocumentos.ultimoContrato != undefined ? (trabajador.ultimosDocumentos.ultimoContrato.estadoDocumento != 1 || trabajador.ultimosDocumentos.ultimoContrato.estadoDocumento ==3) : false) || (trabajador.ultimosDocumentos.ultimoAnexo != undefined ? (trabajador.ultimosDocumentos.ultimoAnexo.estadoDocumento != 1 || trabajador.ultimosDocumentos.ultimoAnexo.estadoDocumento ==3) : false)) && !trabajador.modificarMail && trabajador.tieneMailTrabajador"
                                                @click="enviarDocumentosTrabajadorModal(trabajador)">
                                                Enviar a trabajador
                                            </CButton>
                                        <CButtonGroup size="sm" class="mx-1"
                                            v-show="!trabajador.isModificandoMail && !trabajador.modificarMail"
                                                :content="(trabajador.modificarMail)?'Cancelar':'Modificar Correo'"
                                                v-tippy="{ 
                                                    placement: 'top',
                                                    arrow: true, 
                                                    arrowType: 'round', 
                                                    animation:'fade',
                                                    theme: 'google',
                                                    followCursor : true,
                                                }">
                                                
                                            <CButton 
                                                color="warning" size="sm"
                                                @click="trabajador.modificarMail = true">
                                                <CIcon name="cil-pencil"/>
                                            </CButton>
                                        </CButtonGroup>
                                    </div>
                                    <div v-else-if="tipoDocumentoSelected.valor == 'liquidaciones'">
                                        
                                        <CButton
                                            v-if="trabajador.documento == null || (trabajador.documento != null && !trabajador.documento.hayDocumento)"
                                            size="sm" variant="ghost"
                                            content="Sin Documento"
                                                v-tippy="{ 
                                                    placement: 'top',
                                                    arrow: true, 
                                                    arrowType: 'round', 
                                                    animation:'fade',
                                                    theme: 'google',
                                                    followCursor : true,
                                                }"
                                            >
                                            <CIcon :content="$options.freeSet.cilMeh" />
                                        </CButton>
                                        <div v-else>
                                            <CButton
                                                v-show="trabajador.documento.hayDocumento && !trabajador.tieneMailTrabajador && !trabajador.modificarMail"
                                                class="ml-2"
                                                size="sm" variant="ghost"
                                                style="color:#e55353"
                                                content="El trabajador no tiene correo"
                                                    v-tippy="{ 
                                                        placement: 'top',
                                                        arrow: true, 
                                                        arrowType: 'round', 
                                                        animation:'fade',
                                                        theme: 'google',
                                                        followCursor : true,
                                                    }"
                                                >
                                                <CIcon
                                                    :content="$options.freeSet.cilWarning"
                                                />
                                            </CButton>
                                            <CButton
                                                v-show="trabajador.documento.hayDocumento && trabajador.documento.estadoDocumento != 3 && !trabajador.modificarMail"
                                                class="ml-2"
                                                size="sm" variant="ghost"
                                                style="color:#f9b115"
                                                content="El documento no está aceptado"
                                                    v-tippy="{ 
                                                        placement: 'top',
                                                        arrow: true, 
                                                        arrowType: 'round', 
                                                        animation:'fade',
                                                        theme: 'google',
                                                        followCursor : true,
                                                    }"
                                                >
                                                <CIcon
                                                    :content="$options.freeSet.cilWarning"
                                                />
                                            </CButton>
                                            
                                            
                                            <CButton
                                                content="Este documento ya a sido enviado al trabajador, volver a enviar"
                                                v-tippy="{ 
                                                    placement: 'top',
                                                    arrow: true, 
                                                    arrowType: 'round', 
                                                    animation:'fade',
                                                    theme: 'google',
                                                    followCursor : true,
                                                }"
                                                style="font-size:11px;"
                                                class="btnPrincipalVapp"
                                                :disabled="trabajador.documento.estadoDocumento != '3' || empresa.isLoadingEnvioTodos"
                                                v-show="(empresa.estado == 1 || empresa.estado ==3) && trabajador.documento.hayDocumento && trabajador.documento.enviadoTrabajador && !trabajador.documento.isLoadiongEnvio && !trabajador.modificarMail && trabajador.tieneMailTrabajador"
                                                @click="enviarDocumentoTrabajador(trabajador, empresa.idEmpresa)">
                                                <CIcon :content="$options.freeSet.cilEnvelopeOpen"  />
                                                <CIcon :content="$options.freeSet.cilExpandRight"  />
                                            </CButton>
                                            <CButton
                                                size="sm"
                                                :content="(trabajador.documento.estadoDocumento != 3)?'El documento debe estar aceptado':'Documento listo para enviar a trabajador'"
                                                v-tippy="{ 
                                                    placement: 'top',
                                                    arrow: true, 
                                                    arrowType: 'round', 
                                                    animation:'fade',
                                                    theme: 'google',
                                                    followCursor : true,
                                                }"
                                                class="btnPrincipalVapp"
                                                :disabled="trabajador.documento.estadoDocumento != 3 || empresa.isLoadingEnvioTodos"
                                                v-show="(empresa.estado == 1 || empresa.estado ==3) && trabajador.documento.hayDocumento && !trabajador.documento.enviadoTrabajador && !trabajador.documento.isLoadiongEnvio && !trabajador.modificarMail && trabajador.tieneMailTrabajador"
                                                @click="enviarDocumentoTrabajador(trabajador, empresa.idEmpresa)">
                                                Enviar a trabajador
                                            </CButton>
                                                                    
                                            <CButton
                                                :disabled="true"
                                                class="btnNormalVapp2"
                                                v-show="trabajador.documento.isLoadiongEnvio || trabajador.isModificandoMail">
                                                <span v-show="trabajador.documento.isLoadiongEnvio"><CIcon :content="$options.freeSet.cilLoopCircular" class="imgr" /> enviando</span>
                                                <span v-show="trabajador.isModificandoMail"><CIcon :content="$options.freeSet.cilLoopCircular" class="imgr" /> Modificando</span>
                                            </CButton>
                                                                    
                                                                    

                                            <CInput
                                                v-model="trabajador.mailModificado"
                                                type="text"
                                                horizontal
                                                placeholder="Correo"
                                                :is-valid="trabajador.mailValido"
                                                v-show="trabajador.modificarMail && !trabajador.isModificandoMail"
                                                @keyup="validarMail(trabajador)">
                                                <template #append>
                                                    <CButton 
                                                        color="success" 
                                                        size="sm"
                                                        :disabled="!trabajador.mailValido"
                                                        @click="cambiarCorreoTrabajador(trabajador, empresa.idEmpresa)"
                                                        content="Guardar Correo"
                                                        v-tippy="{ 
                                                            placement: 'top',
                                                            arrow: true, 
                                                            arrowType: 'round', 
                                                            animation:'fade',
                                                            theme: 'google',
                                                            followCursor : true,
                                                        }">
                                                        <CIcon name="cil-check-circle"/>
                                                    </CButton>

                                                    <CButton
                                                        :content="(trabajador.modificarMail)?'Cancelar':'Modificar Correo'"
                                                        v-tippy="{ 
                                                            placement: 'top',
                                                            arrow: true, 
                                                            arrowType: 'round', 
                                                            animation:'fade',
                                                            theme: 'google',
                                                            followCursor : true,
                                                        }"
                                                        v-show="trabajador.modificarMail"
                                                        color="danger" 
                                                        @click="trabajador.modificarMail = false" size="sm" ><CIcon name="cil-x-circle"/>
                                                    </CButton>
                                                </template>
                                            </CInput>
                                                                    
                                                                    
                                                                    <CButtonGroup size="sm" class="mx-1"
                                                                        v-show="portContador && !trabajador.documento.isLoadiongEnvio && !trabajador.isModificandoMail && !trabajador.modificarMail"
                                                                        :content="(trabajador.modificarMail)?'Cancelar':'Modificar Correo'"
                                                                        v-tippy="{ 
                                                                            placement: 'top',
                                                                            arrow: true, 
                                                                            arrowType: 'round', 
                                                                            animation:'fade',
                                                                            theme: 'google',
                                                                            followCursor : true,
                                                                        }"
                                                                    >
                                                                        
                                                                        <CButton 
                                                                            color="warning" size="sm"
                                                                            @click="trabajador.modificarMail = true"
                                                                        >
                                                                            <CIcon name="cil-pencil"/>
                                                                        </CButton>
                                                                    </CButtonGroup>
                                                                </div>
                                        </div>
                                    -->
                                </span>
                                <!-- Tabla expandida -->
                                <div v-if="tipoDocumentoSelected.valor == 'liquidaciones'"
                                    slot="expandedRowRender"
                                    slot-scope="trabajador" style="width:99%; margin: 0">
                                    <CRow>
                                        <CCol>
                                            <a-table
                                                row-key="idDocumento"
                                                :columns="columnasArchivosLiquidaciones" 
                                                :data-source="trabajador.documentos"
                                                :scroll="{ y: 200 }"
                                                class="tableInterior mt-3" 
                                                size="small">
                                                <div slot="nombreArchivo" slot-scope="documento">
                                                    {{documento.nombreDocumento}}
                                                </div>
                                                <div slot="fechaEmision" slot-scope="documento">
                                                    {{$utils.formatFechaDocumento(documento.ultimaGeneracion)}}
                                                </div>
                                                <div slot="documentos" slot-scope="documento">
                                                    <!--Validar cuando ocultarlos!!!-->
                                                    <span v-if="documento.isLoadingDoc">
                                                        <CIcon style="color:#0b7689;" :content="$options.freeSet.cilLoopCircular" class="imgr" />
                                                    </span>
                                                    
                                                    <span v-else-if="(!portContador ? (trabajador.documento != null?(trabajador.documento.estadoDocumento == 1 || trabajador.documento.estadoDocumento == 3):true) : true)">
                                                        <span>
                                                            <a 
                                                                :href="documento.urlDocumento" 
                                                                target="_blank" 
                                                                style="text-decoration: none; color:#0b7689;" 
                                                                content="Descargar Documento"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }"
                                                            >
                                                                <CIcon :name="$utils.iconosGenerales('descarga')" size="xl"/>
                                                            </a>
                                                        </span>
                                                        <span>
                                                            |
                                                            <a  
                                                                style="text-decoration: none; color:#0b7689" 
                                                                content="Ver Documento"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }"
                                                                @click="seleccionarTrabajadores(empresa, trabajador, documento)">
                                                                <CIcon :name="$utils.iconosGenerales('mostrar')" size="xl"/>
                                                            </a>
                                                        </span>
                                                        <span v-if="(portContador)?documento.estadoDocumento != 1 && documento.estadoDocumento != 3 : false">
                                                            |
                                                            <a  
                                                                style="text-decoration: none; color:#0b7689" 
                                                                content="Eliminar Documento"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }"
                                                                @click="eliminarDocumento(empresa, trabajador, documento)">
                                                                <CIcon :name="$utils.iconosGenerales('cancelar')" size="xl"/>
                                                            </a>
                                                        </span>
                                                    </span>
                                                    <span v-else>
                                                        <CButton
                                                        size="sm" variant="ghost"
                                                        content="Sin Documento"
                                                            v-tippy="{ 
                                                                placement: 'top',
                                                                arrow: true, 
                                                                arrowType: 'round', 
                                                                animation:'fade',
                                                                theme: 'google',
                                                                followCursor : true,
                                                            }"
                                                        >
                                                            <CIcon :name="$utils.iconosGenerales('nada')" size="xl" />
                                                        </CButton>
                                                    </span>
                                                </div>
                                                <div slot="estado" slot-scope="documento">
                                                        <span v-if="!documento">
                                                            <CBadge shape="pill" color="secondary" class="large-badge-web">
                                                                Sin Estado
                                                            </CBadge>
                                                        </span>
                                                        <span v-else>
                                                            <CBadge shape="pill" :color="getColorEstadoDocumento(documento)" class="large-badge-web">
                                                                {{$utils.getEstadoDocumento(documento)}}
                                                            </CBadge>
                                                        </span>
                                                    </div>


                                            </a-table>
                                        </CCol>
                                    </CRow>

                                </div>
                                <div v-else-if="tipoDocumentoSelected.valor == 'contratos'"
                                    slot="expandedRowRender"
                                    slot-scope="trabajador" style="width:99%; margin: 0">
                                    <CRow>
                                        <CCol>
                                            <a-table
                                                row-key="idDocumento"
                                                :columns="columnasArchivosContratos" 
                                                :data-source="trabajador.documentos"
                                                :scroll="{ y: 400 }"
                                                class="tableInterior mt-3" 
                                                size="small">

                                                <div slot="tipoDoc" slot-scope="documento">
                                                    {{documento.tipo}}
                                                </div>

                                                <div slot="fechaEmision" slot-scope="documento">
                                                    {{$utils.formatFechaDocumentoNormal(documento.fechaEmision)}}
                                                </div>

                                                <div slot="fechaContrato" slot-scope="documento">
                                                    {{$utils.formatFechaDocumentoNormal(documento.fechaContrato)}}
                                                </div>

                                                <div slot="fechaTermino" slot-scope="documento">
                                                    {{$utils.formatFechaDocumentoNormal(documento.fechaTermino)}}
                                                </div>
                                                
                                                <div slot="fechaVencimiento" slot-scope="documento">
                                                    {{$utils.formatFechaDocumentoNormal(documento.fechaVencimiento)}}
                                                </div>
                                                
                                                <div slot="estado" slot-scope="documento">
                                                    <span v-if="!documento.documento">
                                                        <CBadge shape="pill" color="secondary" class="large-badge-web">
                                                            Sin Estado 
                                                        </CBadge>
                                                    </span>
                                                    <span v-else>
                                                        <CBadge shape="pill" :color="getColorEstadoDocumento(documento.documento)" class="large-badge-web">
                                                            {{ $utils.getEstadoDocumento(documento.documento) }}                                                               
                                                        </CBadge>
                                                    </span>
                                                </div>

                                                <div slot="documentos" slot-scope="documento">
                                                    
                                                    <span v-if="documento.isGenerando || empresa.isLoadingGenerarDocumento || trabajador.isLoadingGenerarDocumento">
                                                        <CIcon :content="$options.freeSet.cilLoopCircular" class="imgr" />
                                                    </span>
                                                    <div v-else>
                                                        <CButton
                                                            v-if="documento.documento == null"
                                                            size="sm" variant="ghost"
                                                            content="Sin Archivo"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }"
                                                            >
                                                            <CIcon
                                                                :name="$utils.iconosGenerales('nada')" size="xl"
                                                            />
                                                        </CButton>
                                                        <span v-else>
                                                            <span v-show="!portContador ? documento.documento.estadoDocumento == 1 || documento.documento.estadoDocumento ==3 : true">
                                                                <a 
                                                                    :href="documento.documento.urlDocumento" 
                                                                    target="_blank" 
                                                                    style="text-decoration: none; color:#0b7689;" 
                                                                    content="Descargar Documento"
                                                                    v-tippy="{ 
                                                                        placement: 'top',
                                                                        arrow: true, 
                                                                        arrowType: 'round', 
                                                                        animation:'fade',
                                                                        theme: 'google',
                                                                        followCursor : true,
                                                                    }"
                                                                >
                                                                    <CIcon :name="$utils.iconosGenerales('descarga')" size="xl"/>
                                                                </a>
                                                                /
                                                                <a
                                                                    style="text-decoration: none; color:#0b7689"
                                                                    content="Ver Documento"
                                                                    v-tippy="{ 
                                                                        placement: 'top',
                                                                        arrow: true, 
                                                                        arrowType: 'round', 
                                                                        animation:'fade',
                                                                        theme: 'google',
                                                                        followCursor : true,
                                                                    }"
                                                                    @click="seleccionarTrabajadores(empresa, trabajador, documento.documento)">
                                                                    <CIcon :name="$utils.iconosGenerales('mostrar')" size="xl"/>
                                                                </a>
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </a-table>
                                        </CCol>
                                    </CRow>
                                </div> 
                        </a-table>
                    </div>
                </div>
            </CCol>
        </CRow>
        <ModalPdfViewDocs
            :prevue="mostrarVisorPDF"
            :trabajadorprev="trabajadorSelectedModal"
            :empresa="empresaSelModal"
            :documento="documentoSelectedModal"
            :periodoSelected="periodoSelected"
            :mesSelected="mesSelected"
            :tipoDocumentoSelected="tipoDocumentoSelected"
            :web="this"
        />
        <Modal :enableClose="false" v-model="envioDocs" title="Seleccionar documentos a enviar">
            <div class="vm-content" v-if="trabEnviar != null">
                <CRow class="mb-2">
                    <CCol md="2" class="text-center font-weight-bold">Enviar</CCol>
                    <CCol md="10" class="font-weight-bold">Información del Documento</CCol>
                </CRow>
                
                <CDropdownDivider />
                
                <div v-for="documento in trabEnviar.documentos" :key="documento.idDocumentoCtro">
                    <CRow>
                        <CCol md="2">
                            <CRow>
                                <CCol>
                                    <div v-if="documento.documento != null" class="text-center">
                                        <CIcon v-if="documento.documento != null" class="ml-2" style="color: #f9b115" v-show="documento.documento &&
                                        documento.estadoDocumento != 3" 
                                        v-c-tooltip.hover="{
                                            content: 'El documento no está aceptado',
                                            placement: 'left',
                                        }" :content="$options.freeSet.cilWarning" />
                                        <CSwitch
                                            :disabled="documento.estadoDocumento != 3"
                                            v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                            width="150px"
                                            class="mx-1 align-middle mb-2"
                                            shape="pill"
                                            variant="outline"
                                            :checked="documento.selecEnviar"
                                            @update:checked="seleccionarDocEnviar(documento)"
                                        />
                                    </div>
                                    <div v-else class="text-center align-middle">
                                        <CButton
                                           size="sm" variant="ghost"
                                            content="Sin Documento"
                                                v-tippy="{ 
                                                    placement: 'top',
                                                    arrow: true, 
                                                    arrowType: 'round', 
                                                    animation:'fade',
                                                    theme: 'google',
                                                    followCursor : true,
                                                }"
                                            >
                                            <CIcon
                                                :content="$options.freeSet.cilMeh"
                                            />
                                        </CButton>
                                    </div>
                                </CCol>
                            </CRow>
                        </CCol>
                        <CCol  md="10">
                            <CRow>
                                <CCol>
                                    <span class="font-weight-bold">Documento</span> {{documento.tipo}}
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol>
                                    <span class="font-weight-bold">Tipo Contrato</span> {{documento.tipoContrato}}
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol>
                                    <span class="font-weight-bold">Fecha Contrato</span> {{$utils.formatFechaDocumentoNormal(documento.fechaContrato)}}
                                </CCol>
                            </CRow>
                            <CRow v-if="documento.documento != null && documento.documento.enviadoTrabajador">
                                <CCol>
                                    <span class="font-weight-bold">Documento enviado a trabajador</span> {{$utils.formatFechaDocumento(documento.documento.fechaEnvioATrabajador)}} 
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <CDropdownDivider />
                </div>
            </div>
            <div class="vm-footer">
                <CButton size="sm" color="success"
                    :disabled="isEnviandoDocumentos || docsSeleccionadosEnviar.length == 0"
                    @click="enviarDocumentoTrabajadorModal">
                    <CIcon 
                    :content="isEnviandoDocumentos?$options.freeSet.cilLoopCircular:$options.freeSet.cilEnvelopeOpen"
                    :class="isEnviandoDocumentos?'imgr':''"
                    /> {{isEnviandoDocumentos?'Enviando':'Enviar'}}
                </CButton>

                <CButton class="float-right" size="sm" color="danger" 
                :disabled="isEnviandoDocumentos" 
                    @click="envioDocs = false">
                    <CIcon :name="$utils.iconosGenerales('cancelar')"/> Salir
                </CButton>
            </div>
        </Modal>
    </div>
    
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    import cons from "@/const";
    import Multiselect from "vue-multiselect";
    import axios from "axios";
    import apiUrls from '@/views/utils/apiUrls'

    import VueModal from "@kouts/vue-modal";
    import "@kouts/vue-modal/dist/vue-modal.css";

    import { freeSet } from "@coreui/icons";
    
    import ModalPdfViewDocs from "./ModalPdfViewDocs";
    import OpcionesEnvioCorreo from "./tablasComponentes/opcionesEnvioCorreo";

    export default {
        name: "TablaEmpresas",
        freeSet,
        props: {
            portContador: Boolean,
            empresa: Object,
            periodoSelected: Object,
            mesSelected: Object,
            periodoCerrado: Boolean,
            trabajadores: Array,
            loading: Boolean,
            paginacion: Object,
            totalTrabajadores: Number,
            totalTrabajadoresDocumentos: Number,
            tipoDocumentoSelected: Object,
            isLoadingGenerarDocumento: Boolean,
            revision: Object,
            mostrarPeriodo: Boolean,
            tablaLista: Boolean,
        },
        components: {
            Multiselect,
            'Modal': VueModal,
            ModalPdfViewDocs,
            OpcionesEnvioCorreo
        },
        data() {
            return {
                tokenLogin: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
                urlBase: cons.port+"://" + cons.ipServer,
                
                empresaSelModal: null,
                trabajadorSelectedModal: {},
                documentoSelectedModal: null,
                mostrarVisorPDF: false,
                
                
                envioDocs: false,
                trabEnviar: null,
                docsSeleccionadosEnviar: [],
                isEnviandoDocumentos: false,
                
                localeTrabajadores: {
                    emptyText: ' '
                },
                columnasTrabajadores: [
                    { title: 'Rut', scopedSlots:{ customRender: 'rutTrabajador' }, key: 'rutTrabajador', width: '10%', ellipsis: true},// width: '10%'
                    { title: 'Trabajador', dataIndex: 'nombreTrabajador', key: 'nombreTrabajador',  width: '30%', ellipsis: true},// width: '20%'
                    //{ title: 'Última Generación', key: 'generacion', scopedSlots: { customRender: 'generacion' }, width: '20%', align: 'center', ellipsis: true},
                    //{ title: 'Estado Dcto.', key: 'estadoDocumento', scopedSlots: { customRender: 'estadoDocumento' }, width: '10%', align: 'center', ellipsis: false},
                    { slots: {title: 'tituloDoc'}, key: 'documento', scopedSlots: { customRender: 'documento' }, ellipsis: false, width: '20%', align: 'center'},// width: '10%'
                    {title: "Enviar Docto", scopedSlots: { customRender: 'envioCorreo' }, width: "40%", align: "center"}// width: '20%'
                ],

                columnasArchivosContratos: [
                    { title: 'Tipo Dcto.', scopedSlots: { customRender: 'tipoDoc' }, width: '10%', align: 'left' ,ellipsis: false},
                    { title: 'Fecha Emisión', scopedSlots:{ customRender: 'fechaEmision' }, width: '20%', align: 'center', ellipsis: false},
                    { title: 'Fecha Início Contrato', scopedSlots: { customRender: 'fechaContrato' }, width: '15%', align: 'left', ellipsis: false},
                    { title: 'Fecha Vencimiento', scopedSlots: { customRender: 'fechaVencimiento' }, width: '15%', align: 'center', ellipsis: false},
                    { title: 'Fecha Término', scopedSlots: { customRender: 'fechaTermino' }, width: '15%', align: 'center', ellipsis: false},
                    { title: 'Documentos', scopedSlots: { customRender: 'documentos' }, width: '15%', align: 'center', ellipsis: false},
                    { title: 'Estado', scopedSlots: { customRender: 'estado' }, width: '10%', align: 'center', ellipsis: false},
                ],
                
                columnasArchivosLiquidaciones: [
                    { title: 'Nombre', scopedSlots: { customRender: 'nombreArchivo' }, width: '20%', align: 'left' ,ellipsis: false},
                    { title: 'Fecha Emisión', scopedSlots:{ customRender: 'fechaEmision' }, width: '20%', align: 'center', ellipsis: false},
                    { title: 'Documentos', scopedSlots: { customRender: 'documentos' }, width: '20%', align: 'center', ellipsis: false},
                    { title: 'Estado', scopedSlots: { customRender: 'estado' }, width: '20%', align: 'center', ellipsis: false},
                ],

                mostrarTablaA: false,

            };
        },
        created: function () {
        },
        beforeMount() {
            
        },
        methods: {
            expandirTarjeta: function(trabajador){
                trabajador.expandirTrabajador = !trabajador.expandirTrabajador;
            },
            eliminarDocumento: function(empresa, trabajador, documento){

                let url = `${this.urlBase}${apiUrls.remuneraciones.eliminarDocTrabajador}`

                documento.isLoadingDoc = true

                axios({
                    method: "POST",
                    "url": url,
                    "data": {
                        "tipoBd": "REMU",
                        "idEmpresa": empresa.idEmpresa,
                        "idDocumento": documento.idDocumento,
                        "mesPeriodo": (this.mesSelected != null) ? this.mesSelected.valor : null,
                        "anioPeriodo": (this.periodoSelected != null) ? this.periodoSelected.valor : null,
                        "tipoDocumento": (this.tipoDocumentoSelected != null) ? this.tipoDocumentoSelected.valor : null,
                        "filtrarPorPeriodo": this.mostrarPeriodo
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    if(trabajador.documento.idDocumento == documento.idDocumento){
                        trabajador.documento = null
                    }
                    trabajador.documentos.forEach(doc => {
                        if(doc.idDocumento == documento.idDocumento){
                            var index = trabajador.documentos.indexOf(doc)
                            trabajador.documentos.splice(index, 1)
                        }
                    })
                    this.mostrarNotificaciones(1, `${result.data.mensajeGeneral}`)

                },(error) => {
                        this.mostrarNotificaciones(3, `${error.response.data.mensajeGeneral}`)
                    }
                )
                .finally(() => {
                    if(documento != null){
                        documento.isLoadingDoc = false
                    }
                });

                /*if(trabajador.documento.idDocumento == documento.idDocumento){
                    trabajador.documento = null
                }
                trabajador.documentos.forEach(doc =>{
                    if(doc.idDocumento == documento.idDocumento){
                        var index = trabajador.documentos.indexOf(doc)
                        trabajador.documentos.splice(index, 1)
                    }

                    
                })*/
                /*axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "tipoBd": "REMU",
                        "idEmpresa": empresa.idEmpresa,
                        "idDocumento": documento.idDocumento,
                        "mesPeriodo": (this.mesSelected != null) ? this.mesSelected.valor : null,
                        "anioPeriodo": (this.periodoSelected != null) ? this.periodoSelected.valor : null,
                        "tipoDocumento": (this.tipoDocumentoSelected != null) ? this.tipoDocumentoSelected.valor : null,
                        "filtrarPorPeriodo": this.mostrarPeriodo
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    this.mostrarNotificaciones(3, `${result.data.mensajeGeneral}`)


                },(error) => {
                        this.mostrarNotificaciones(3, `${error.response.data.mensajeGeneral}`)
                        
                        
                    }
                )
                .finally(() => {
                });*/
            },
            descargarDocumento: function(doc){
                const link = document.createElement('a')
                link.href = doc.urlDocumento
                link.download = doc.nombreDocumento
                link.click()
                URL.revokeObjectURL(link.href)
            },
            seleccionarTrabajadores: function(empresa, trabajador, documento){
                
                this.empresaSelModal = empresa
                this.trabajadorSelectedModal = trabajador
                this.documentoSelectedModal = documento
                //this.getTrabajadoresModal()
                //this.trabajadorSelected = trabajador
                this.mostrarVisorPDF = true

            },
            handleTableChange: function(pagination, filters, sorter, filasActuales){
                pagination.empresa.paginacion = pagination;
                this.paginacion = pagination;
                //pagination.empresa.paginacion = pagination
                //this.revision.obtenerTrabajadores(this.empresa);
                this.$emit('obtenerTrabajadores', this.empresa);
            },
            generarDocumentoTrabajador: function(empresa, trabajador, documento){
                this.mostrarNotificaciones(3, "Generar!")
                
                /*if(documento != undefined){
                    documento.isGenerando = true
                }
                trabajador.isLoadingGenerarDocumento = true
                var url = cons.port+"://" + cons.ipServer + "/generar_documentos_tabajadores/"
                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "idEmpresa": empresa.idEmpresa,
                            "mesPeriodo": (this.mesSelected != null) ? this.mesSelected.valor : null,
                            "anioPeriodo": (this.periodoSelected != null) ? this.periodoSelected.valor : null,
                            "tipoDocumento": (this.tipoDocumentoSelected != null) ? this.tipoDocumentoSelected.valor : null,
                            "trabajadores": [trabajador.rutTrabajador],
                            "idDocumento": (documento != undefined)?documento.idDocumentoCtro:null,
                            "filtrarPorPeriodo": this.mostrarPeriodo
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {

                    console.log(result.data)
                    this.$notification.success(
                        result.data.mensaje,
                        {timer: 10, position: "bottomRight"}
                    );
                    if(documento != undefined){
                        
                        var hayGenerando = false

                        trabajador.documentos.forEach(docto => {
                            if(docto.idDocumentoCtro == result.data.docTrabajador.idCtro){
                                documento.documento = result.data.docTrabajador.documento
                            }

                            if(documento.isGenerando)
                                hayGenerando = true
                        });
                        
                        documento.isGenerando = false

                        if(!hayGenerando){
                            trabajador.isLoadingGenerarDocumento = false
                        }
                    } else{
                        var hayGenerando = false
                        trabajador.documentos.forEach(docto => {
                            if(docto.isGenerando)
                                hayGenerando = true
                        });
                        if(!hayGenerando){
                            trabajador.isLoadingGenerarDocumento = false
                        }

                        this.revision.obtenerTrabajadores(true, empresa)
                    }

                }, error => {
                    if(documento != undefined)
                        documento.isGenerando = false

                    var hayGenerando = false
                    trabajador.documentos.forEach(docto => {
                        if(docto.isGenerando)
                            hayGenerando = true
                    });
                    if(!hayGenerando){
                        trabajador.isLoadingGenerarDocumento = false
                    }
                    this.mensajeNotificacion = "Ups, Tuvimos un problema al obtener los Documentos, si el problema persiste contacte con nuestro soporte, Gracias."
                    this.$notification.error(error.response.data.mensaje,{ timer: 10, position: "bottomRight" });
                })
                .finally(() => {
                    if(documento != undefined)
                        documento.isGenerando = false

                    var hayGenerando = false
                    trabajador.documentos.forEach(docto => {
                        if(docto.isGenerando)
                            hayGenerando = true
                    });
                    if(!hayGenerando){
                        trabajador.isLoadingGenerarDocumento = false
                    }
                });*/

            },
            enviarDocumentoTrabajador: function(trabajador, idEmpresa){
                trabajador.documento.isLoadiongEnvio = true
                var url = cons.port + "://" + cons.ipServer + "/" + "enviar_documento_trabajador/"
                
                axios({
                    method: "POST",
                    url: url,
                    "data": {
                        "trabajadoresEnviar": {
                        "enviarTodos": false,
                        "idEmpresa": idEmpresa,
                        "anioPeriodo": this.periodoSelected.valor,
                        "mesPeriodo": this.mesSelected.valor,
                        "tipoDoc": this.tipoDocumentoSelected.valor,
                        "trabajadores":[{"rutTrabajador": trabajador.rutTrabajador}]
                        }
                    },
                    headers: {
                        Authorization: `${this.tokenLogin}`,
                    },
                    })
                    .then((result) => {
                        this.$notification.success(
                        result.data.mensaje,
                        { timer: 10, position: "bottomRight" }
                        );
                    },
                    (error) => {
                        this.$notification.error(
                        error.response.data.mensaje,
                        { timer: 10, position: "bottomRight" }
                        );
                    }
                    )
                    .finally(() => {
                        trabajador.documento.isLoadiongEnvio = false
                        //this.revision.obtenerTrabajadores(this.empresa)
                        this.$emit('obtenerTrabajadores', this.empresa);
                    });
            },
            enviarDocumentoTrabajadorModal: function(){
                this.isEnviandoDocumentos =  true
                let idDocumentosEnviar = []
                this.docsSeleccionadosEnviar.forEach(documento => {
                    idDocumentosEnviar.push(documento.idDocumentoCtro)
                });

                var url =  this.urlBase + "/enviar_documentos_trabajador/"

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "mes": (this.mesSelected != null) ? this.mesSelected.valor : null,
                            "anio": (this.periodoSelected != null) ? this.periodoSelected.valor : null,
                            "trabajador": this.trabEnviar,
                            "idDocumentosEnviar": idDocumentosEnviar,
                            "tipoDocumentos": (this.tipoDocumentoSelected != null) ? this.tipoDocumentoSelected.valor : null,
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    this.mostrarNotificaciones(1, result.data.mensajeGeneral)
                    
                    this.isEnviandoDocumentos =  false
                }, error => {
                    this.mostrarNotificaciones(3, error.response.data.mensajeGeneral)
                    this.isEnviandoDocumentos =  false
                })
                .finally(() => {
                });
            },

            enviarDocumentosTrabajadorModal: function(trabajador){
                    this.envioDocs = true
                    this.trabEnviar = trabajador
                    this.docsSeleccionadosEnviar = []

            },

            seleccionarDocEnviar: function(documento){
                documento.selecEnviar = !documento.selecEnviar
                if(documento.selecEnviar)
                    this.docsSeleccionadosEnviar.push(documento)
                else{
                    var index = this.docsSeleccionadosEnviar.indexOf(documento)
                    this.docsSeleccionadosEnviar.splice(index, 1)
                }
            },
            getColorEstadoDocumento: function(documento){
                switch(documento.estadoDocumento) {
                    case 1: return "info"
                    case 2: return "danger"
                    case 3: return "success"
                    default: return "secondary"
                }

            },
            /*getEstadoDocumento: function(documento){
                if(documento.hayDocumento){
                    switch(documento.estadoDocumento) {
                        case 1: return "En Revisión"
                        case 2: return "Rechazado"
                        case 3: return "Aceptado"
                        default: return "Sin Enviar"
                    }
                } else{
                    return "Sin Documento"
                }
            }*/
        },
    };
</script>


<style scoped>
.ant-table-wrapper{
    min-height: 400px;
}

.tippy-tooltip.google-theme{
  background-color:#29235C;
  font-weight: normal;
}
.tippy-tooltip.google-theme .tippy-backdrop {
  
  background-color:#29235C;
}
.tippy-content{
  background-color: transparent;
}
.btn-pad{
    padding: 5px;
    margin: 5px;
}
.col-mob{
    display: flex; 
    justify-content: center;
}
.large-badge-web {
    font-size: 13px; /* Aumenta el tamaño del texto */
    padding: 5px 14px; /* Aumenta el espacio interno */
}
.large-badge-movil {
    font-size: 12px; /* Aumenta el tamaño del texto */
    padding: 5px 15px; /*Aumenta el espacio interno */
}
.center-content-badge {
    display: flex;
    justify-content: center; /* Centra horizontalmente */
    align-items: center; /* Centra verticalmente */
    height: 40%;
    padding-bottom: 10px; /* Asegúrate de que haya espacio suficiente */
}
.center-content-expandir {
    display: flex;
    justify-content: center; /* Centra horizontalmente */
    align-items: center; /* Centra verticalmente */
    padding-bottom: 15px;
}
.center-content {
    display: flex;
    justify-content: center; /* Centra horizontalmente */
    align-items: center; /* Centra verticalmente */
    height: 100%; /* Asegúrate de que haya espacio suficiente */
}
/* Card liquidaciones */
/* Superposición para el CardBody */
.card-overlay {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
  z-index: 10;

  /* Inicio animación: oculto fuera de la vista */
  transform: translateX(100%);
  opacity: 0;
  transition: transform 0.4s ease, opacity 0.4s ease;
}

/* Cuando el CardBody está expandido */
.card-overlay.is-expanded {
  transform: translateX(0);
  opacity: 1;
}

/* El CCardHeader y CCard original */
.liquidacion {
  position: relative;
  overflow: hidden; /* Asegura que el overlay esté contenido */
}

/* Tarjeta contratos */
.card-container {
  display: flex;
  flex-direction: column;
  gap: 20px; /* Espaciado entre tarjetas */
}
.card-wrapper {
  position: relative;
  overflow: hidden;
}
</style>